import { faSpinner } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import clsx from 'clsx'
import { forwardRef } from 'react'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import {
  actionItem,
  actionItemActive,
  actionItemDisabled,
  actionItemLegacy
} from './ActionTrigger.css'

export const ActionTrigger = forwardRef<
  HTMLDivElement,
  React.HTMLProps<HTMLDivElement> & {
    icon: any
    title?: string
    active?: boolean
    isLegacy?: boolean
    limitReached?:
      | {
          limit: number
          label: string
        }
      | false
    disabledReason?: string
    loading?: boolean
    onActionHover?: (hover: boolean) => void
  }
>(
  (
    {
      icon,
      active,
      title,
      onActionHover,
      limitReached,
      disabledReason,
      loading = false,
      onClick,
      isLegacy = false,
      ...rest
    },
    ref
  ) => {
    const isDisabled = !!limitReached || !!disabledReason || loading
    const Button = (
      <div
        className={clsx(
          actionItem,
          active ? actionItemActive : null,
          isDisabled ? actionItemDisabled : null,
          isLegacy ? actionItemLegacy : null
        )}
        ref={ref}
        title={title}
        onMouseEnter={() => onActionHover?.(true)}
        onMouseLeave={() => onActionHover?.(false)}
        onClick={(e) => {
          if (isDisabled) {
            e.preventDefault()
            e.stopPropagation()
            return
          }
          onClick?.(e)
        }}
        {...rest}
      >
        <FontAwesomeIcon icon={loading ? faSpinner : icon} spin={loading} />
      </div>
    )
    if (limitReached) {
      return (
        <Tooltip
          text={`Vous ne pouvez pas effectuer cette action avec plus de ${limitReached.limit} candidat${limitReached.limit > 1 ? 's' : ''} à la fois`}
          asChild
          direction="top"
        >
          {Button}
        </Tooltip>
      )
    }
    if (disabledReason) {
      return (
        <Tooltip text={disabledReason} asChild direction="top">
          {Button}
        </Tooltip>
      )
    }
    if (isLegacy) {
      return (
        <Tooltip text={title} asChild direction="top">
          {Button}
        </Tooltip>
      )
    }
    return Button
  }
)
